import React from 'react';

import './index.scss';

// eslint-disable-next-line react/prop-types
export default function BodyBold({ children }) {
  return (
    <div className="body-bold">{ children }</div>
  );
}
